import React from 'react';
import MuiModal from '@/Components/atoms/MuiModal';
import { useIsMobile } from '@/Hooks/useIsMobile';
import { MakeComplainTitle } from './style';
import { useTranslation } from 'next-i18next';
import { IconButton, Stack } from '@mui/material';
import CommonSvg, { svgNames } from '@/Components/atoms/CommonSvg';
const MakeComplainForm = React.lazy(() => import('./MakeComplainForm'));

type Props = {
  productId: number;
  isOpen: boolean;
  onClose: () => void;
}

const MakeComplainModal: React.FC<Props> = ({ isOpen, onClose, productId }) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();


  return (
    <MuiModal
      open={isOpen}
      onClose={onClose}
      fullScreen={isMobile}
      sx={{
        '.MuiDialog-paper': {
          borderRadius: isMobile ? 0 : '10px',
        }
      }}
    >
      <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mb={2}>
        <MakeComplainTitle>
          { t('product_page.complaint') }
        </MakeComplainTitle>
        <IconButton onClick={onClose} sx={{ color: '#222', width: '40px', height: '40px' }} disableRipple>
          <CommonSvg name={svgNames.Close} />
        </IconButton>
      </Stack>
      {
        isOpen && <React.Suspense fallback=''>
          <MakeComplainForm productId={productId} />
        </React.Suspense>
      }
    </MuiModal>
  )
}

export default MakeComplainModal;
